<script lang="ts" setup>
import { getError } from '@autobid/strapi-integration/utils/getError'

interface Props {
  carId: number
  watched: boolean
}

const props = defineProps<Props>()
const emits = defineEmits(['update'])

const { t } = useI18n()
const { $trpc } = useNuxtApp()
const push = usePush()

const loading = ref(false)

async function handleClick() {
  if (loading.value)
    return

  loading.value = true
  emits('update', !props.watched)

  try {
    if (props.watched) {
      await $trpc.webapi.unwatchCar.mutate({ carId: props.carId })
      push.success(t('cars-list.car-unwatch-success'))
    }
    else {
      await $trpc.webapi.watchCar.mutate({ carId: props.carId })
      push.success(t('cars-list.car-watch-success'))
    }
  }
  catch (err) {
    const { message, handled } = getError(err)

    if (!handled) {
      push.error(message)
    }

    // restore previous value - was updated optimistically
    emits('update', !props.watched)
  }

  loading.value = false
}
</script>

<template>
  <CommonTooltip
    :tooltip="
      !watched ? $t('cars-list.observer-car') : $t('cars-list.unobserve-car')
    "
  >
    <DynamicAuctionItemListCarIcon
      :variant="watched ? 'primary' : 'border'"
      size="big"
      v-bind="$attrs"
      @click.stop="handleClick"
    >
      <span class="sr-only">
        {{
          !watched
            ? $t('cars-list.observer-car')
            : $t('cars-list.unobserve-car')
        }}
      </span>
      <CommonIconEye class="h-full w-full" />
    </DynamicAuctionItemListCarIcon>
  </CommonTooltip>
</template>
